import Api from 'libs/api/index';

class CustomerLogsApi extends Api {
  constructor() {
    super('cv/customer_logs/');
  }
}

export default CustomerLogsApi;
